document.addEventListener('DOMContentLoaded', function () {
  // ========================================
  // STICKY ADD TO CART - OPTIMIZED VERSION
  // ========================================
  
  // DOM Elements - Fixed selectors (removed extra spaces)
  const mainAtcButton = document.querySelector('.ProductForm__AddToCart');
  const stickyContainer = document.querySelector('[data-sticky-cart]');
  const stickyAtcButton = document.querySelector('[data-sticky-atc]');
  const stickyPrice = document.querySelector('.sticky_price');
  const productItems = document.querySelectorAll('.ProductForm__Item');
  const variantSelector = document.querySelector('.ProductForm__Variants');
  
  // Early exit if elements don't exist
  if (!mainAtcButton || !stickyContainer || !stickyAtcButton) {
    console.warn('Sticky cart: Required elements not found');
    return;
  }
  
  // No text states needed - button text stays constant
  
  // ========================================
  // 1. INTERSECTION OBSERVER - Show/Hide Sticky
  // ========================================
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };
  
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Main button is visible → Hide sticky
        stickyContainer.classList.remove('sticky_handle');
      } else {
        // Main button is not visible
        if (entry.boundingClientRect.top < 0) {
          // Button is above viewport → Show sticky
          stickyContainer.classList.add('sticky_handle');
        } else {
          // Button is below viewport → Hide sticky
          stickyContainer.classList.remove('sticky_handle');
        }
      }
    });
  };
  
  const intersectionObserver = new IntersectionObserver(handleIntersection, observerOptions);
  intersectionObserver.observe(mainAtcButton);
  
  // ========================================
  // 2. SYNC BUTTON STATE (disabled/enabled)
  // ========================================
  function syncButtonState() {
    if (mainAtcButton.disabled || mainAtcButton.hasAttribute('disabled')) {
      stickyAtcButton.classList.add('disabled');
    } else {
      stickyAtcButton.classList.remove('disabled');
    }
  }
  
  // Initial sync
  syncButtonState();
  
  // Watch for changes in main button state
  const buttonStateObserver = new MutationObserver(syncButtonState);
  buttonStateObserver.observe(mainAtcButton, { 
    attributes: true, 
    attributeFilter: ['disabled', 'class'] 
  });
  
  // ========================================
  // 3. CLICK HANDLER - Add to Cart or Scroll to Variants
  // ========================================
  stickyAtcButton.addEventListener('click', function (e) {
    e.preventDefault();
    
    // Check if button is disabled
    if (stickyAtcButton.classList.contains('disabled')) {
      return;
    }
    
    // Check if we need to select a variant first
    const requiresVariantSelection = mainAtcButton.hasAttribute('data-require-variant-selection');
    const hasVariants = variantSelector && variantSelector.children.length > 0;
    
    if (requiresVariantSelection && hasVariants) {
      // Check if a variant is selected
      const hiddenInput = document.querySelector('input[type="hidden"][name="id"]');
      const hasSelectedVariant = hiddenInput && hiddenInput.value && hiddenInput.value !== '';
      
      if (!hasSelectedVariant) {
        // No variant selected → Scroll to variant selector
        scrollToVariantSelector();
        return;
      }
    }
    
    // Variant is selected or not required → Add to cart
    mainAtcButton.click();
  });
  
  // ========================================
  // 4. SCROLL TO VARIANT SELECTOR
  // ========================================
  function scrollToVariantSelector() {
    if (!variantSelector) return;
    
    const offset = 100; // Offset from top
    const elementPosition = variantSelector.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    
  }
  
  // ========================================
  // 5. UPDATE PRICE ON VARIANT CHANGE
  // ========================================
  function updateStickyPrice() {
    const productPrice = document.querySelector('.ProductMeta__Price');
    if (productPrice && stickyPrice) {
      stickyPrice.innerHTML = productPrice.innerHTML;
    }
  }
  
  // Watch for variant changes via aria-expanded
  const priceObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        updateStickyPrice();
      }
    });
  });
  
  // Observe all variant selector items
  productItems.forEach((item) => {
    priceObserver.observe(item, { attributes: true });
  });
  
  // Also listen for variant:changed event (if theme uses it)
  document.addEventListener('variant:changed', updateStickyPrice);
  
});